// extracted by mini-css-extract-plugin
module.exports = {"link":"_6f25b66c20--link--3zOkr"};